angular.module('bribac.views.home', [
  'ngRoute',
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.components.whenLoaded',
  'bribac.components.searchForm',
  'bribac.components.mainGroupOverview',
  'bribac.components.subjectOverview'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/', {
      templateUrl: 'home-view.html',
      controller: 'HomeViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('HomeViewCtrl', function(
    $scope,
    KINDS,
    api,
    permissions,
    state
  ) {
    var $ctrl = this
    $ctrl.permissions = permissions

    $ctrl.KINDS = KINDS
    $ctrl.dataLoaded = false

    if (state.currentAgent) {
      // send empty promise to immediately load the view without waiting
      $ctrl.statePromise = new Promise(function (resolve) {
        requestAnimationFrame(resolve)
      });
      $ctrl.organization = state.lastSelectedOrganization || state.currentAgent.organization
      updateFilter()
      $scope.$watch('$ctrl.filter', reloadFilter)
      $scope.$watch('$ctrl.organization', reloadOrganizations)
    } else {
      $ctrl.filter = 'all'
      // when status is not loaded in time, we need to populate it
      $ctrl.statePromise = loadStatus().then(function () {
        $scope.$watch('$ctrl.filter', reloadFilter)
        $scope.$watch('$ctrl.organization', reloadOrganizations)
      });
    }

    function updateFilter() {
      if (state.lastSelectedFilter) {
        $ctrl.filter = state.lastSelectedFilter[$ctrl.organization && $ctrl.organization.id] || 'all'
      } else {
        $ctrl.filter = 'all'
      }
    }

    function reloadFilter(newFilter, oldFilter) {
      if (oldFilter === newFilter) {
        // Nothing to load
        return
      }
      reloadData()
    }

    function reloadOrganizations(newOrganization, oldOrganization) {
      if (($ctrl.dataLoaded && newOrganization && oldOrganization) && newOrganization.id === oldOrganization.id) {
        return;
      }
      updateFilter()
      loadMainGroups()
      reloadData()
    }

    function loadMainGroups() {
      var filter = ''
      if ($ctrl.organization.id !== -1) {
        filter = '?organization=' + $ctrl.organization.id
      }
      $ctrl.mainGroupPromise = api.getFilteredByOrg(KINDS.MAIN_GROUP, filter).then(function (response) {
        $ctrl.mainGroups = response.data.list
        $ctrl.noGroups = response.data.total === 0
      })
    }

    function reloadData() {
      var endpoint = 'dashboard?'

      var kind = KINDS.MAIN_GROUP

      if ($ctrl.organization) {
        state.lastSelectedOrganization = $ctrl.organization
        if ($ctrl.organization.id !== -1) {
          endpoint = endpoint + 'organization=' + $ctrl.organization.id
        }
      }

      if ($ctrl.filter === 'inactive') {
        endpoint = endpoint + '&inactive=true'
        kind = KINDS.SUBJECT
      } else if ($ctrl.filter === 'highlighted') {
        endpoint = endpoint + '&highlighted=true'
        kind = KINDS.SUBJECT
      } else if ($ctrl.filter !== 'all') {
        endpoint = endpoint + '&mainGroup=' + $ctrl.filter
        kind = KINDS.MAIN_GROUP
      }

      $ctrl.viewPromise = api.getView(endpoint).then(function (request) {

          let enrichedData;

          if (request.data) {
              enrichedData = request.data.map(function (data) {
                  if (!data || !Array.isArray(data.subGroups)) {
                      return data;
                  }

                  const enrichedSubGroups = data.subGroups.map(function (subGroup) {
                      if (!subGroup || !Array.isArray(subGroup.subjects)) {
                          return subGroup;
                      }

                      const enrichedSubjects = subGroup.subjects.map(function (subject) {
                          if (!subject) {
                              return subject;
                          }

                          return Object.assign({}, subject, {organization: data.organization || null});
                      });

                      return Object.assign({}, subGroup, {subjects: enrichedSubjects});
                  });

                  return Object.assign({}, data, { subGroups: enrichedSubGroups });
              });
          }

        $ctrl.filteredData = {
          kind: kind,
          entities: enrichedData
        }

        $ctrl.dataLoaded = true;

        if ($ctrl.organization) {
          state.lastSelectedFilter[$ctrl.organization.id] = $ctrl.filter
        }
      })
    }

    function loadStatus() {
     return api.getMe().then(
          function success(request) {
            var agent = request.data
            state.currentAgent = agent
            state.currentAgent.permissions = permissions.getPermissionsForRole(agent.roles[0])

            $ctrl.organization = state.currentAgent.organization

            return request
          }
      )
    }


  })
